import { parseArcgisLocationLink } from '../ResourceTab/arcgisFeatureLocation';
import { epaFacilityIdFromResourceNotes } from '../NotificationsTab/epaGulfThreatNotification';
import { facilityIdFromAnyFacilityDemoNotes } from '../NotificationsTab/facilityDemoPack';
import { heleneStoreIdFromResourceNotes } from '../NotificationsTab/memphisThreatNotification';
import { uscgFocSeAssetIdFromResourceNotes } from '../NotificationsTab/uscgFocSoutheastThreatNotification';
import type { AssetSymbolTarget } from './assetSymbolMatch';

export type AssetSymbolSource = {
  resource_set_id: string;
  id?: string | null;
  name?: string | null;
  notes?: string | null;
  arcgis_location_link?: unknown;
};

/**
 * How an asset's symbol is recognized on the map: its own ids and name, the
 * demo facility id kept in its notes, and any linked ArcGIS feature.
 */
export function assetSymbolTargetFor(
  resource: AssetSymbolSource
): AssetSymbolTarget {
  const link = parseArcgisLocationLink(resource.arcgis_location_link);
  const matchIds = [
    resource.resource_set_id,
    resource.id,
    resource.name,
    heleneStoreIdFromResourceNotes(resource.notes),
    epaFacilityIdFromResourceNotes(resource.notes),
    facilityIdFromAnyFacilityDemoNotes(resource.notes),
    uscgFocSeAssetIdFromResourceNotes(resource.notes),
  ].flatMap((id) => {
    const trimmed = id?.trim();
    return trimmed ? [trimmed] : [];
  });
  return {
    resourceSetId: resource.resource_set_id,
    matchIds: [...new Set(matchIds)],
    layerId: link?.external_layer_id,
    objectId: link?.object_id,
  };
}
